import { useEffect, useState } from 'react';
import { Skeleton } from '@/shared/components/ui/skeleton';

interface TextPreviewProps {
  blob: Blob;
}

export function TextPreview({ blob }: TextPreviewProps) {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    blob
      .text()
      .then(setText)
      .catch(() => setText(null));
  }, [blob]);

  if (text === null) {
    return (
      <div className="flex flex-1 flex-col gap-2 p-4" data-testid="project-files-text-preview">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-4 w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-auto bg-muted/20 p-4" data-testid="project-files-text-preview">
      <pre className="whitespace-pre-wrap break-all font-mono text-xs text-foreground">{text}</pre>
    </div>
  );
}
